<template>
  <div style="background-color: #F9FBFD;">
    <div class="smartmedical_header">
      <div class="smartmedical_header_img">
        <img src="../assets/banner-1.png" alt="">
      </div>
      <div class="smartmedical_header_title" id="smartmedical_header_title">
        <div class="smartmedical_header_box"
          :style="index == titIndex || Number(index) + 6 == titIndex  ? 'color: #1D2B3E;' : ''"
          v-for="(item,index) in titleList" :key="index" @click="handleSelect(index)">
          <span>{{item.name}}</span>
        </div>
        <div class="tab-activation-item" :style="{
          		left: (smartmedicalleft + 338)+'px',
          	}"></div>
        <div class="smartmedical_header_title_board">
          <div style="font-size: 24px;color: #ffffff;margin-bottom: 7px;">Medical Education</div>
          <div style="width: 48px;height: 3px;background-color: #ffffff;margin-bottom: 5px;"></div>
          <div style="font-size: 24px;color: #ffffff;">智慧医教</div>
        </div>
      </div>
    </div>

    <div v-if="titIndex == 0">
      <div class="w">
        <div class="smartmedical_sponline_title">
          标准化病人培训体系/SP Education system
        </div>
        <div class="talents-case">
          <div class="talents-case-box">
            <div class="talents-case-box-img">
              <el-image style="width: 312px; height: 239px;" :src="SPteacher" :fit="fit">
              </el-image>
            </div>
            <div class="talents-case-box-title">SP师资培训</div>
            <div class="talents-case-box-box">SP师资培训课程，打破教师学习的时间、空间限制，分享丰富、优质的教师教学经验，学习SP管理、教学方法。</div>
          </div>
          <div class="talents-case-box">
            <div class="talents-case-box-img">
              <el-image style="width: 312px; height: 239px;" :src="SPtraining" :fit="fit">
              </el-image>
            </div>
            <div class="talents-case-box-title">SP人员培训</div>
            <div class="talents-case-box-box">新上线SP人员培训视频课程，通过线上学习、考核、认证获得参与教学资格。</div>
          </div>
          <div class="talents-case-box">
            <div class="talents-case-box-img">
              <el-image style="width: 312px; height: 239px;" :src="Standardvideo" :fit="fit">
              </el-image>
            </div>
            <div class="talents-case-box-title">标准教学视频</div>
            <div class="talents-case-box-box">优秀的学生案例可以提供给同学们参考学习，增加同学之间的沟通于交流，打造良好的学习氛围。</div>
          </div>
        </div>
        <div class="smartmedical_sponline_title">
          标准化病人常态化教学/SP Normalized teaching
        </div>
        <div class="smartmedical_sponline_centre">
          <div class="smartmedical_sponline_centre_img">
             SP走进课堂
           <!-- <el-image style="width: 400px; height: 196px;" lazy :src="zoujinketang" :fit="fit">
              SP走进课堂
            </el-image> -->
          </div>
          <div class="smartmedical_sponline_centre_box">
            除考试应用之外，SP可以走进课堂，帮助完成常态化教学场景，包括角色扮演、模拟病例讨论、实际操作演练、模拟情境教学等等，让学生实际操作并得到及时的反馈和指导。在模拟的情境中学习分析病情、制定治疗方案，锻炼临床思维等能力。
          </div>
        </div>
        <div class="smartmedical_sponline_foot">
          <div class="smartmedical_sponline_foot_online">
            <div class="smartmedical_sponline_foot_online_img">
              <div v-for="(item,index) in callist" :key="item.id">
                <el-image class="smartmedical_sponline_foot_online_image" style="width: 341px; height: 694px;"
                  v-if="index == tabindex" :class="Imagesuoflage  ? 'smartmedical_sponline_foot_online_active' : ''"
                  :src="item.avatar" :fit="fit">
                </el-image>
              </div>

            </div>
            <div class="smartmedical_sponline_foot_online_tab">
              <div class="smartmedical_sponline_foot_online_tab_title">线上教学</div>
              <div class="smartmedical_sponline_foot_online_tab_box"
                :style="index == tabindex  ? 'background-color: #FFFFFF;color: #1A7BFC;' : ''"
                @mouseover="tabchange(index)" v-for="(item,index) in callist" :key="item.id">
                {{item.title}}
              </div>
            </div>
          </div>
          <div class="smartmedical_sponline_foot_offline">

            <div class="smartmedical_sponline_foot_offline_title">线下教学</div>
            <el-carousel height="445px" direction="horizontal" arrow="never" :autoplay="false">
              <el-carousel-item v-for="(item,index) in onlist" :key="index">

                <div class="smartmedical_sponline_foot_offline_img">
                  <el-image style="width: 407px; height: 312px;" :src="item.avatar" :fit="fit">
                  </el-image>

                </div>
                <div class="smartmedical_sponline_foot_offline_title1">{{item.subtitle}}</div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div v-if="titIndex == 1">
      <div class="w">
        <!-- <div class="smartmedical_project_title">
          医教方案/Medical Education Program
        </div>
        <div class="smartmedical_project_img">
          <img src="../assets/mas.png" alt="">
        </div>
        <div class="smartmedical_project_title">
          码上评
        </div>
        <div class="smartmedical_project_content">
          码上评管理系统是通过信息化方式进行在线技能测评，系统支持线下扫码评、线上实时评、日常作业评三种形式。教师可随时发起码上评任务，学生通过手机完成任务，邀请教师进行评分。解决了教师布置作业难，任务追溯慢，评价管理繁等实际问题。
        </div> -->
        <div class="news-information-title">训练常态化/Normalization Of Training</div>
        <div class="news_carousel">
          <el-carousel type="card" :initial-index="imgIndex" ref="carousel" @change="carouselChange" arrow="never"
            :autoplay="false">
            <el-carousel-item v-for="item in slidelist1" :key="item.id" height="100%">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div
                    :class="item.id === activeSlide && item.id !== null && item.id !== '' ? 'swiper-slide_img_active' : 'swiper-slide_img'">
                    <img :src="item.avatar" alt="">
                  </div>
                  <div
                    :class="item.id === activeSlide && item.id !== null && item.id !== '' ? 'swiper-slide_title_active' : 'swiper-slide_title'">
                    {{item.title}}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="news-information-title">考试常态化/Exam Normalization</div>
        <div class="news_carousel">
          <el-carousel type="card" :initial-index="imgIndex" ref="carousel" @change="carouselChange1" arrow="never"
            :autoplay="false">
            <el-carousel-item v-for="item in slidelist2" :key="item.id" height="100%">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div
                    :class="item.id === activeSlide1 && item.id !== null && item.id !== '' ? 'swiper-slide_img_active' : 'swiper-slide_img'">
                    <img :src="item.avatar" alt="">
                  </div>
                  <div
                    :class="item.id === activeSlide1 && item.id !== null && item.id !== '' ? 'swiper-slide_title_active' : 'swiper-slide_title'">
                    {{item.title}}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="news-information-title">实习过程常态化/Normalize The PracticeProcess</div>

        <div class="Normalize">
          <div class="Normalize_box">
            <div class="Normalize_box_title">
              学生完成任务
            </div>
            <div class="Normalize_box_img">
              <el-image style="width: 341px; height: 507px;" :src='slide11' :fit="fit">
              </el-image>
            </div>
          </div>
          <div class="Normalize_box">
            <div class="Normalize_box_title">
              邀请带教老师评分
            </div>
            <div class="Normalize_box_img">
              <el-image style="width: 341px; height: 507px;" :src='slide12' :fit="fit">
              </el-image>
            </div>
          </div>
        </div>
        <div class="Normalize" style="margin-top: 36px;">
          <div class="Normalize_box" style="padding-bottom: 50px;">
            <div class="Normalize_box_title">
              发布实施计划
            </div>
            <div class="Normalize_box_img">
              <el-image style="width: 486px; height: 256px;" :src='slide13' :fit="fit">
              </el-image>
            </div>
          </div>
          <div class="Normalize_box">
            <div class="Normalize_box_title">
              查看实习评价结果
            </div>
            <div class="Normalize_box_img">
              <el-image style="width: 486px; height: 256px;" :src='slide14' :fit="fit">
              </el-image>
            </div>
          </div>
        </div>
        <div style="width: 100%;height: 100px;">

        </div>
        <!-- <div class="swiper-container">
          <div class="swiper-wrapper" ref="mySwiper">
            <div class="swiper-slide" v-for="item in slidelist1" :key="item.id">
              <div
                :class="item.id === activeSlide && item.id !== null && item.id !== '' ? 'swiper-slide_img_active' : 'swiper-slide_img'">
                <img :src="item.avatar" alt="">
              </div>
              <div
                :class="item.id === activeSlide && item.id !== null && item.id !== '' ? 'swiper-slide_title_active' : 'swiper-slide_title'">
                {{item.title}}</div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div> -->
        <!-- <div class="swiper-container" style="height: 1001px;">
          <div class="swiper-wrapper">
            <div class="swiper-slide grey-slide">
              <div class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s"
                swiper-animate-delay="0.3s">
                <div class="news-content">
                  <div class="news-content-img">
                    <img src="../assets/tongc.png" alt="">
                  </div>
                  <div class="news-information-title">同侪互评</div>
                  <div class="news-content-box">
                    同侪互评训练系统基于微信小程序开发，内置大量评分表，并且支持用户自己上传评分表，同学之间通过扫一扫即可实现面对面自由评分，学习训练项相关资源。通过这种方式满足同学间开展互助学习、互助训练的需要，肯定成绩、找出不足，促进同侪相互提高。极大提高了同侪训练热情，同时也极大降低了指导教师的工作量。
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide grey-slide">
              <div class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s"
                swiper-animate-delay="0.3s">
                <div class="news-content">

                  <div class="news-content-img1">
                    <img src="../assets/mas.png" alt="">
                  </div>
                  <div class="news-information-title">码上评</div>
                  <div class="news-content-box">
                    码上评管理系统是通过信息化方式进行在线技能测评，系统支持线下扫码评、线上实时评、日常作业评三种形式。教师可随时发起码上评任务，学生通过手机完成任务，邀请教师进行评分。解决了教师布置作业难，任务追溯慢，评价管理繁等实际问题。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import 'swiper/dist/js/swiper'
  import 'swiper/dist/css/swiper.css'
  import Swiper from "swiper"
  import Online from "../assets/Online.png"
  import everyday from "../assets/everyday.png"
  import makeOnline from "../assets/makeOnline.png"
  import Studentrecord from "../assets/Studentrecord.png"
  import Offlineexamination from "../assets/Offlineexamination.png"
  import appointmentonline from "../assets/appointmentonline.png"
  import SPtraining from "../assets/SPtraining.png"
  import SPteacher from "../assets/SPteacher.png"
  import zoujinketang from "../assets/zoujinketang.png"
  import Standardvideo from "../assets/Standardvideo.png"
  import slide1 from "../assets/slide1.png"
  import slide2 from "../assets/slide2.png"
  import slide3 from "../assets/slide3.png"
  import slide4 from "../assets/slide4.png"
  import slide5 from "../assets/slide5.png"
  import slide6 from "../assets/slide6.png"
  import slide7 from "../assets/slide7.png"
  import slide8 from "../assets/slide8.png"
  import slide9 from "../assets/slide9.png"
  import slide10 from "../assets/slide10.png"
  import slide11 from "../assets/slide11.png"
  import slide12 from "../assets/slide12.png"
  import slide13 from "../assets/slide13.png"
  import slide14 from "../assets/slide14.png"



  let vm = null
  export default {
    data() {
      return {
        fit: 'fill',
        titleList: [{
            name: 'SP在线',
            value: 0
          },
          {
            name: '医教方案',
            value: 1
          }
        ],
        titIndex: 0,
        smartmedicalwidth: 0,
        smartmedicalheight: 4,
        smartmedicalleft: 0,
        callist: [{
            id: 0,
            title: '线上预约',
            avatar: Online
          },
          {
            id: 1,
            title: '日常训练',
            avatar: everyday
          },
          {
            id: 2,
            title: '线上考试',
            avatar: makeOnline
          },
          {
            id: 3,
            title: '学生训练记录',
            avatar: Studentrecord
          },

        ],
        onlist: [{
            id: 0,
            title: '线下教学',
            subtitle: '线下考试',
            avatar: Offlineexamination
          },
          {
            id: 1,
            title: '线上教学',
            subtitle: '线下预约',
            avatar: appointmentonline
          }
        ],
        tabindex: 0,
        SPtraining: SPtraining,
        SPteacher: SPteacher,
        zoujinketang: zoujinketang,
        Standardvideo: Standardvideo,
        Imagesuoflage: true,
        activeSlide: 0,
        activeSlide1: 0,
        slidelist1: [{
            id: 0,
            title: '选择训练项目',
            avatar: slide1
          },
          {
            id: 1,
            title: '自主练习',
            avatar: slide2
          },
          {
            id: 2,
            title: '扫码评分',
            avatar: slide3
          },
          {
            id: 3,
            title: '学生互评',
            avatar: slide4
          },
          {
            id: 4,
            title: '评价结果',
            avatar: slide5
          },
        ],
        slidelist2: [{
            id: 0,
            title: '创建任务',
            avatar: slide6
          },
          {
            id: 1,
            title: '线上视频即时评分',
            avatar: slide7
          },
          {
            id: 2,
            title: '线下面对面评分',
            avatar: slide8
          },
          {
            id: 3,
            title: '日常作业上传评分',
            avatar: slide9
          },
          {
            id: 4,
            title: 'OSCE考试远程评分',
            avatar: slide10
          },
        ],
        imgIndex: 0,
        slide12: slide12,
        slide11: slide11,
        slide13: slide13,
        slide14: slide14



      }
    },
    watch: {
      titIndex(newVal) {
        this.titIndex = newVal
        this.$nextTick(() => {
          let _this = this
          _this.init()
          // new Swiper('.swiper-container', {
          //   direction: 'horizontal', // 垂直切换选项
          //   slidesPerView: 3,
          //   initialSlide: _this.activeIndex,
          //   centeredSlides: true,
          //   spaceBetween: 30,
          //   initialSlide: 2,
          //   loop: true,
          //   pagination: {
          //     el: '.swiper-pagination',
          //     clickable: true, // 分页器可以点击
          //   },
          //   on: {
          //     slideChange: function() {
          //       if (this.activeIndex > 7) {
          //         _this.activeSlide = 0
          //       } else if (this.activeIndex == 2) {
          //         _this.activeSlide = 4
          //       } else {
          //         _this.activeSlide = this.activeIndex - 3
          //       }
          //       _this.$forceUpdate()

          //     },
          //   },



          // })
        })
      }
    },

    mounted() {

      // new Swiper('.swiper-container', {
      //   direction: 'horizontal', // 垂直切换选项
      //   //mousewheel: true, //滚轮
      //   // autoplay: { //自动开始
      //   //   delay: 2500, //时间间隔
      //   //   disableOnInteraction: false, //*手动操作轮播图后不会暂停*
      //   // },
      //   slidesPerView: 3,
      //   centeredSlides: true,
      //   spaceBetween: 30,
      //   loop: true,
      //   // 如果需要分页器
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true, // 分页器可以点击
      //   },
      // })
    },
    created() {
      if (this.$route.query.place) {
        this.titIndex = this.$route.query.place
      } else {
        this.titIndex = 0
      }
    },
    methods: {
      carouselChange(e) {
        this.activeSlide = e
      },
      carouselChange1(e) {
        this.activeSlide1 = e
      },
      tabchange(index) {
        this.tabindex = index
        this.Imagesuoflage = false
        let _this = this
        setTimeout(function() {
          _this.Imagesuoflage = true

        }, 100);
      },
      handleSelect(index) {
        this.titIndex = index
        this.$router.push({
          query: {
            place: this.titIndex
          }
        })
      },
      init() {
        let data = document.getElementsByClassName('smartmedical_header_box')
        if (data.length) {
          let arr = []
          for (var i = 0; i < data.length; i++) {
            arr.push(data[i].clientWidth)
          }
          let titIndexnum = 0
          if (Number(this.titIndex) > 5) {
            this.smartmedicalwidth = arr[Number(this.titIndex) - 6]
            titIndexnum = Number(this.titIndex) - 6
          } else {
            this.smartmedicalwidth = arr[this.titIndex]
            titIndexnum = this.titIndex
          }
          this.smartmedicalleft = arr.slice(0, titIndexnum).reduce((num, item) => {
            return num + item + 70
          }, 0)
          document.getElementById('smartmedical_header_title').scrollLeft = this.smartmedicalleft - arr[this
            .titIndex] / 2;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .w {
    width: 1200px !important;
    margin: 0 auto;
  }

  .smartmedical_header {
    width: 100%;
    position: relative;
  }

  .smartmedical_header_img {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .smartmedical_header_title {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
    height: 85px;
    padding-left: 348px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    background-color: #ffffff;
  }

  .smartmedical_header_title_board {
    position: absolute;
    left: 0;
    top: -84px;
    width: 269px;
    height: 169px;
    background-color: #1A7BFC;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 27px;
  }

  .smartmedical_header_box {
    display: inline-block;
    color: #808080;
    font-size: 16px;
    cursor: pointer;
    margin-right: 70px;
    z-index: 99;
  }

  .tab-activation-item {
    background: #1D2B3E;
    position: absolute;
    top: 41px;
    left: 0;
    z-index: 9;
    transition: all 0.3s linear;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .smartmedical_sponline_title {
    margin-top: 80px;
    font-size: 30px;
    width: 100%;
    text-align: center;
    font-weight: 600;
  }

  .smartmedical_sponline_centre {
    width: 100%;
    padding: 31px 32px;
    height: 258px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 12px;
    margin-top: 50px;
  }

  .smartmedical_sponline_centre_img {
    width: 400px;
    height: 196px;
    border-radius: 12px;
    overflow: hidden;
    margin-right: 32px;
    background: url('../assets/zoujinketang.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #FFFFFF;
  }

  .smartmedical_sponline_centre_box {
    width: 704px;
    line-height: 36px;
    font-size: 16px;
    color: #8693A4;
  }

  .smartmedical_sponline_img {
    width: 540px;
    margin: 50px auto 0;

    img {
      width: 100%;
    }

  }

  .smartmedical_sponline_content {
    width: 914px;
    padding: 32px 0 80px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 42px;
    color: #8693A4;
    text-align: center;
  }

  .smartmedical_project_title {
    margin-top: 80px;
    font-size: 30px;
    width: 100%;
    text-align: center;
    font-weight: 600;
  }

  .smartmedical_project_img {
    width: 641px;
    height: 383px;
    margin: 50px auto 0;

    img {
      width: 100%;
    }
  }

  .smartmedical_project_content {
    width: 914px;
    padding: 32px 0 80px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 42px;
    color: #8693A4;
    text-align: center;
  }

  .swiper-container {
    width: 100%;
    background-color: #FFFFFF;
    padding: 50px 0;
    box-sizing: border-box;
  }

  .swiper-pagination /deep/ .swiper-pagination-bullet-active {
    background-color: #1A7BFC;
    width: 33px;
    border-radius: 20px;
  }

  .swiper-pagination /deep/ .swiper-pagination-bullet {
    background-color: #1A7BFC;
    width: 33px;
    border-radius: 20px;
  }

  // .swiper-pagination-bullet {
  //   background: rgba(26, 123, 252, .2);
  //   width: 33px;
  //   border-radius: 20px;
  // }

  .news-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .news-information-title {
    width: 100%;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    margin-top: 80px;
    margin-bottom: 50px;
  }

  .news-content-img {
    margin-top: 90px;
    width: 540px;
    height: 540px;
    margin-bottom: 90px;
  }

  .news-content-img1 {
    margin-top: 90px;
    width: 540px;
    height: 540px;
    margin-bottom: 90px;
  }


  .news-content-box {
    width: 914px;
    font-size: 16px;
    text-align: center;
    color: #8693A4;
    line-height: 42px;
    margin-top: 16px;
  }



  .talents-case {
    width: 100%;
    height: 100%;
    padding: 50px 0 0;
    overflow: hidden;

  }

  .talents-case-box {
    padding: 32px;
    width: 376px;
    height: 483px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 36px;
    cursor: pointer;
    border-radius: 12px;
  }

  .talents-case-box:nth-child(3n) {
    margin-right: 0;
  }

  .talents-case-box-img {
    width: 312px;
    height: 239px;
  }

  .talents-case-box-title {
    width: 100%;
    font-size: 20px;
    color: #1A7BFC;
    font-weight: 600;
    margin: 32px 0 16px;
  }

  .talents-case-box-box {
    width: 100%;
    font-size: 16px;
    line-height: 36px;
    color: #8693A4;
  }

  .smartmedical_sponline_foot {
    width: 100%;
    height: 539px;
    padding: 65px 0 100px;
    display: flex;
    justify-content: space-between;
  }

  .smartmedical_sponline_foot_online {
    width: 694px;
    height: 539px;
    background: #EEF5FF;
    border-radius: 12px;
    padding-top: 32px;
    display: flex;
    box-sizing: border-box;
  }

  .smartmedical_sponline_foot_online_img {
    width: 341px;
    height: 507px;
    margin-left: 32px;
    margin-right: 60px;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
  }

  .smartmedical_sponline_foot_offline {
    width: 471px;
    height: 539px;
    background: #EEF5FF;
    border-radius: 12px;
    padding: 32px 0;
    box-sizing: border-box;
    text-align: center;
  }

  .smartmedical_sponline_foot_offline_title {
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    color: #1A7BFC;
    margin-bottom: 22px;
    text-align: left;
    padding-left: 32px;
  }

  .smartmedical_sponline_foot_offline_title1 {
    font-size: 16px;
    color: #8693A4;
    margin-top: 32px;
  }

  .smartmedical_sponline_foot_offline_img {
    width: 471px;
    height: 312px;
    display: flex;
    justify-content: center;
    overflow: hidden;
  }

  .smartmedical_sponline_foot_online_tab {
    width: 228px;
    height: 507px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .smartmedical_sponline_foot_online_tab_title {
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    color: #1A7BFC;
    margin-bottom: 22px;
  }

  .smartmedical_sponline_foot_online_tab_box {
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    border-radius: 12px;
    font-size: 16px;

    color: #8693A4;
    cursor: pointer;
  }

  .el-carousel__item {
    // background: #EEF5FF;

  }

  /deep/ .el-carousel__button {
    height: 6px !important;
    border-radius: 6px;
    background-color: rgba(26, 123, 252, .2);

  }


  /deep/ .is-active .el-carousel__button {
    // 指示器激活按钮
    background: rgba(26, 123, 252, 1) !important;
  }





  .smartmedical_sponline_foot_online_image {
    // transition: 2s;
    // transform: scale(1.0); //放大倍数
  }

  .smartmedical_sponline_foot_online_active {
    transition: 2s; //动画过渡的更加顺滑
    transform: scale(0.9); //放大倍数
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  .swiper-slide_img {
    width: 203px !important;
    height: 415px !important;

    img {
      width: 100%;
    }
  }

  .swiper-slide_title {
    width: 100%;
    text-align: center;
    margin: 73px 0;
    font-size: 16px;
    color: #8693A4;
  }

  .swiper-slide_title_active {
    display: inline-block;
    padding: 0 63px;
    height: 60px;
    font-size: 20px;
    color: #1A7BFC;
    border-radius: 30px;
    border: 1px solid #1A7BFC;
    text-align: center;
    line-height: 60px;
    margin: 60px 0;
  }

  .swiper-slide_img_active {
    width: 245px;
    height: 499px;
    border-radius: 40px;
    overflow: hidden;
    box-shadow: 0px 10px 31px 0px rgba(26, 123, 252, 0.3);

    img {
      width: 100%;

    }

  }

  .swiper-wrapper {
    display: flex;
    align-items: flex-end;
  }

  .news_carousel /deep/ .el-carousel__container {
    height: 692px !important;

  }

  .news_carousel /deep/ .el-carousel {
    background-color: #fff;
    padding: 50px 0px;
    border-radius: 12px;
  }

  .Normalize {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .Normalize_box {
    width: 582px;
    background-color: #FFFFFF;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
  }

  .Normalize_box_title {
    text-align: center;
    font-size: 26px;
    font-weight: 600;
    margin: 50px auto 32px;
    color: #1D2B3E;
  }

  .Normalize_box_img {
    display: flex;
    justify-content: center;
  }
</style>
